module.exports = __webpack_public_path__ + "img/yellow-arrow.6b032b63.png";